import styles from "./Hero.module.scss";
import { StartPageType } from "@/types/ModuleOptionsType";
import { useSublinesVisibility } from "../../../hooks/useSublinesOverlinesVisibility";
import { Header_Startseite } from "@aleksundshantu/schirdewan-standard-types/acf-header";
import { ExtendedLink } from "@/components/ExtededLink/ExtendedLink";
import { passACFLink } from "@/utils/passACFLink";
import { Post } from "@aleksundshantu/schirdewan-standard-types/client";
import { Headline } from "@/components/Headline/Headline";
import { Button } from "@/components/Button/Button";
import { HeroSlider } from "./HeroSlider/HeroSlider";
import { Section } from "@/components/Section/Section";

export type HeroSlideType = Exclude<
  Header_Startseite["header_startseite"]["elements"],
  false
>[number]["media"] & {
  videoData?: Post<"videos">;
};

interface HeroProps {
  header: Header_Startseite["header_startseite"];
  startPageOptions: StartPageType;
  navbarHasBackground: boolean;
}

export const Hero = ({ header, startPageOptions }: HeroProps) => {
  const { elements, title, overline, subline } = header;

  const {
    // imageheader: {
    //   vertical_align: imageheaderVerticalAlign,
    //   text_horizontal_align: imageheaderTextHorizontalAlign,
    //   text_vertical_align: imageheaderTextVerticalAlign,
    //   headline_gradient: imageheaderHeadlineGradient,
    //   image_height: imageheaderImageHeight,
    //   text_width: imageheaderTextWidth,
    // },
    button_type,
    show_overline_subline,
    second_button_type,
    two_buttons,
    // splitheader: {
    //   image_height: splitheaderImageHeight,
    //   media_format: splitheaderMediaFormat,
    //   header_width: splitheaderWidth,
    //   text_vertical_align: splitheaderTextVerticalAlign,
    //   text_width_with_spacer: splitheaderTextWidthWithSpacer,
    //   row_direction_class_mobile: splitHeaderVerticalDirection,
    // },
    show_extended_link,
  } = startPageOptions;

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  const contentJSX = (
    <Section
      disableColumns
      disableContainer
      className={`${styles["header-info-wrapper"]}`}
    >
      {title && (
        <Headline
          headline_html_tag={"h1-hero"}
          headline={title}
          overline={showOverline ? overline : ""}
          subline={showSubline ? subline : ""}
          disableAnimation
          staggerSpans
          extraClass="has-text-centered"
        />
      )}

      <div className={`content`}>
        {header.teasertext.title && (
          <span className="title">{header.teasertext.title}</span>
        )}
        {header.teasertext.content && (
          <div
            className="intro-text"
            dangerouslySetInnerHTML={{
              __html: header.teasertext.content,
            }}
          />
        )}
        <div className={`content ${styles["links-wrapper"]}`}>
          {show_extended_link ? (
            <>
              {header.link_extended && (
                <ExtendedLink
                  extendedLink={header.link_extended}
                  btnType={
                    button_type
                      ? button_type
                      : header.link_extended.type === "email"
                        ? "secondary"
                        : "primary"
                  }
                />
              )}
              {two_buttons && header.link_2_extended && (
                <ExtendedLink
                  extendedLink={header.link_2_extended}
                  btnType={
                    button_type
                      ? button_type
                      : header.link_2_extended.type === "email"
                        ? "secondary"
                        : "primary"
                  }
                />
              )}
            </>
          ) : (
            <>
              {header.link && header.link.url && (
                <Button
                  type={button_type ?? "primary"}
                  {...passACFLink(header, "link")}
                >
                  {header.link.title}
                </Button>
              )}
              {two_buttons && header.link_2 && header.link_2.url && (
                <Button
                  type={second_button_type ?? "secondary"}
                  {...passACFLink(header, "link_2")}
                >
                  {header.link_2.title}
                </Button>
              )}
            </>
          )}
        </div>
      </div>

      {/* <div className={`is-hidden-touch ${styles["the-left-logo"]}`}>
        <CustomSVG
          src={getIcon("theLeft")}
          width={180}
          height={24}
          aria-label="The Left Logo"
        />
      </div> */}
    </Section>
  );

  const elementsJSX = Array.isArray(elements) && elements.length > 0 && (
    <HeroSlider elements={elements.map((el) => el.media)} />
  );

  return (
    <header className={`${styles["startseite-header"]}`}>
      {contentJSX}
      {elementsJSX}
    </header>
  );
};
